import { GlowButton, Header, SupportedBy } from "../components";
import styles from "./styles/hero.module.scss";
import { useNavigate } from "react-router-dom";

import { ReactComponent as MaskHero } from "../assets/images/mask_hero.svg";
import { ReactComponent as MaskHeroFront } from "../assets/images/mask_hero_front.svg";
import Strings from "../strings/strings";

export const HeroSection = (className: React.HTMLAttributes<HTMLDivElement>) => {
  const navigate = useNavigate();

  return (
    <>
      <div {...className}>
        {Header()}
        <div className={styles.intro}>
          <div className={styles.heroTextTitle}>
            <div className={styles.title}>
              <span>{Strings.heroTitle}</span>
            </div>
            <div className={styles.text}>{Strings.heroSubtitle}</div>
            <div className={styles.contactUsButton}>
              {GlowButton({
                text: Strings.heroJoinBtn,
                onClick: () => navigate("/products"),
              })}
            </div>
          </div>
          <div className={styles.maskHero}>
            <MaskHero style={{ width: "100%", height: "100%" }} />
          </div>
          <div className={styles.maskHeroFront}>
            <MaskHeroFront style={{ width: "100%", height: "100%" }} />
          </div>
        </div>
        <SupportedBy />
      </div>
    </>
  );
};
